// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_ed8","badges":"styles_badges__239oG"};